export enum SignatureProviderEnum {
    safeID = 1,
    techCert = 2,
    vidaaS = 3
}